import { Box } from "@mui/material";
import React from "react";
import Form from "./Form";
import { useSelector } from "react-redux";
import Table from "./Table";
import DataExport from "./DataExport";
import CollapseSection from "../../../components/ui/CollapseSection";

export default function QuotaDetails() {
  const state = useSelector((store) => store.analyze);
  const { quotaDetailsDataPrepared, clearAnalyzeQuotaDetails } = state;
  return (
    <Box>
      <Form />
      {quotaDetailsDataPrepared !== null && clearAnalyzeQuotaDetails && (
        <CollapseSection title="Analyze Quota Details">
          {/* <DataExport /> */}
          <Table />
        </CollapseSection>
      )}
    </Box>
  );
}
